import { motion } from 'framer-motion';
import { FiAward, FiUsers, FiHeart, FiStar } from 'react-icons/fi';

const About = () => {
  const stats = [
    { icon: FiAward, number: '500+', label: 'Events Styled' },
    { icon: FiUsers, number: '50+', label: 'Happy Clients' },
    { icon: FiHeart, number: '100%', label: 'Satisfaction' },
    { icon: FiStar, number: '5', label: 'Star Rating' }
  ];


  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-800 mb-6 pt-[50px]">
            About Melbourne Floral Hire
          </h2>
          <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
            We are Melbourne's premier faux floral hire service, specializing in creating
            breathtaking arrangements for weddings, corporate events, and special celebrations.
          </p>
        </motion.div>

        {/* Story Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20"
        >
          <div>
            <h3 className="text-3xl font-bold text-neutral-800 mb-6">Our Story</h3>
            <div className="space-y-4 text-neutral-600">
              <p>
                Founded with a passion in floral artistry, Melbourne Floral Hire began as a small family business with a simple mission: to make premium floral arrangements accessible for all special occasions.
              </p>
              <p>
                What started as a weekend project has grown into Melbourne's most trusted artficial floral hire and event design service, serving hundreds of satisfied clients across all special events and working with a wide list of high-end venues in melbourne.
              </p>
            </div>
          </div>

          <div className="relative">
            <img
              src="/images/about.png"
              alt="About Melbourne Floral Hire"
              className="aspect-square rounded-2xl object-cover"
            />
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary-200 rounded-full opacity-20" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-primary-100 rounded-full opacity-30" />
          </div>
        </motion.div>

        {/* Why We're Different — merged from WhyChooseUs.js */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <h2 className="text-5xl font-bold text-neutral-800 mb-4">Why We're Different</h2>
          <div className="text-lg text-neutral-600 max-w-4xl mx-auto space-y-4">
            <p>We love what we do. We are passionate about transforming events into beautifully aesthetic and luxurious experiences.</p>
            <p>Our team brings extensive experience across the event industry, led by our lead floral designer with over a decade of expertise in floral styling and professional training in fresh floral artistry.</p>
            <p>We love listening to your creative ideas. Bringing our client's vision and art to life is part of our passion and the backbone of our business.</p>
            <p>We offer an all-in-one experience by providing a wide range of styling elements, helping to simplify the planning process and reduce the need for multiple vendors.</p>
            <p>We provide budget flexible packages that are thoughtfully curated to suit a variety of event designs, ensuring beautiful results without compromise.</p>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default About;